import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { Athletes, Tryout } from "./athlete.model";
import { Teams } from "../club/club.model";

@Injectable({ providedIn: 'root' })
export class AthleteService {

    constructor(private http: HttpClient) { }

    async findTeamsCategory(idClub: number, idCountry: number, idSport: number, idAthlete?: number) {
        let params = new HttpParams();
        params = params.set('club', idClub.toString());
        params = params.set('country', idCountry.toString());
        params = params.set('sport', idSport.toString());
        let url = idAthlete ? <Teams[]>await this.http.get(environment.urlApi.concat('/athletes/' + idAthlete + '/teams'), { params: params }).toPromise() : <Teams[]>await this.http.get(environment.urlApi.concat('/athlete/teams'), { params: params }).toPromise();
        return url;
    }

    // async findAthletesByParent(parent: number) {
    //     let params = new HttpParams();
    //     params = params.set('items', '100');
    //     if (parent) { params = params.set('parent', parent.toString()) };
    //     return <Athletes[]>await this.http.get(environment.urlApi.concat('/parent-athletes'), { params: params }).toPromise();
    // }

    async findAthletes(parent: number) {
        let params = new HttpParams();
        params = params.set('items', '100');
        if (parent) { params = params.set('parent', parent.toString()) };
        return <Athletes[]>await this.http.get(environment.urlApi.concat('/athletes'), { params: params }).toPromise();
    }

    async findAthletesByParams(data: { sport: number, ageFrom: number, ageTo: number, idClub?: number, category?: number, page: number }) {
        let params = new HttpParams();
        params = params.set('page', data.page.toString());
        params = params.set('items', '25');
        params = params.set('sport', data.sport.toString());
        params = params.set('ageFrom', data.ageFrom.toString());
        params = params.set('ageTo', data.ageTo.toString());
        if (data.category) { params = params.set('category', data.category.toString()) };
        if (data.idClub) { params = params.set('club', data.idClub.toString()) };
        return <Athletes[]>await this.http.get(environment.urlApi.concat('/athletes'), { params: params }).toPromise();
    }

    async findAthlete(idAthlete?: number) {
        let url = idAthlete ? <Athletes[]>await this.http.get(environment.urlApi.concat('/athletes/' + idAthlete)).toPromise() : <Athletes[]>await this.http.get(environment.urlApi.concat('/athlete')).toPromise();
        return url;
    }

    async findAthletesClubs(idClub: number, category: string) {
        let params = new HttpParams();
        if (category) {
            params = params.set('category', category.toString());
        }
        return <Athletes[]>await this.http.get(environment.urlApi.concat('/clubs/' + idClub + '/athletes/available'), { params: params }).toPromise();
    }

    addAthlete(body: any) {
        return this.http.post(environment.urlApi.concat('/athlete'), body);
    }

    addAthleteBirthCertificate(idAthlete: number, blob: Blob) {
        let formData: FormData = new FormData();
        formData.append('birthDoc', blob, 'birthDoc.jpg');
        return this.http.put(environment.urlApi.concat('/athletes/' + idAthlete + '/birth-doc'), formData);
    }

    async findAtletePending() {
        return await this.http.get(environment.urlApi.concat('/athletes/pending')).toPromise();
    }

    addBioBaselineAthlete(body: any, idAthlete?: number) {
        if (idAthlete) return this.http.post(environment.urlApi.concat('/athletes/' + idAthlete + '/bio'), body);
        else return this.http.post(environment.urlApi.concat('/athlete/bio'), body);
    }

    addTeamAthlete(body: any, idAthlete) {
        let url = idAthlete ? this.http.post(environment.urlApi.concat('/athletes/' + idAthlete + '/team'), body) : this.http.post(environment.urlApi.concat('/athlete/team'), body);
        return url;
    }

    async getProfilePic(idAthlete?: number) {
        if (idAthlete) return await this.http.get(environment.urlApi.concat('/athletes/' + idAthlete + '/img'), { responseType: 'blob' as 'json' }).toPromise();
        else return await this.http.get(environment.urlApi.concat('/users/profile/img'), { responseType: 'blob' as 'json' }).toPromise();;
    }

    async getBirthCertPic(idAthlete: number) {
        return await this.http.get(environment.urlApi.concat(`/athletes/${idAthlete}/birth-doc`), { responseType: 'blob' as 'json' }).toPromise();
    }

    updateAthleteData(data, idAthlete) {
        return this.http.post(environment.urlApi.concat(`/athletes/${idAthlete}`), data);
    }

    async findFreeAthletesClub(sport:number, category: number, gender:string, page:number) {
        let params = new HttpParams();
        params = params.set('page', page.toString());
        params = params.set('items', '20');
        params = params.set('sport', sport.toString());
        if (category) { params = params.set('category', category.toString()) };
        if (gender == 'male' || gender == 'female' || gender == 'other') { params = params.set('gender', gender.toString()) };
        params = params.set('club', '-1');
        return <Athletes[]>await this.http.get(environment.urlApi.concat('/athletes'), { params: params }).toPromise();
    }

    async findAthletesPenddingParQ() {
      return <Athletes[]>await this.http.get(environment.urlApi.concat('/athletes/parqp')).toPromise();
    }

    async uploadParQPlus(idAthlete: number, file: File) {
      let formData: FormData = new FormData();
      formData.append("doc", file, file.name);
      return idAthlete ? this.http.put(environment.urlApi.concat('/athletes/' + idAthlete + '/parqp'), formData).toPromise() : this.http.put(environment.urlApi.concat('/athlete/parqp'), formData).toPromise();
    }

    async updatePositionAthlete(idAthlete: number, body) {
      let url = idAthlete ? this.http.put(environment.urlApi.concat('/athletes/' + idAthlete + '/positions'), body).toPromise() : this.http.put(environment.urlApi.concat('/athletes/positions'), body).toPromise();
      return url;
    }
}
